import { HttpStatus } from '@nestjs/common';

export class IMicroserviceClientResponse<T> {
  message: string;
  data: T;
  errors?: Array<any>;
  status: HttpStatus;
  errorCode?: string;
}
